import React, { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "./tattoo/lib/supabaseClient";

// Sign-in page — /signin
// The public marketing homepage lives at / (LandingPage.jsx).
// Pricing lives at /pricing.

export default function Landing() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const trimmed = email.trim();
    if (!trimmed) return;

    try {
      setStatus("sending");

      // Redirect the magic link back to whichever origin the user signed
      // in from — works for localhost dev, Vercel previews, and prod.
      // Each origin must be in Supabase's Redirect URL allowlist.
      const redirectTo = `${window.location.origin}/auth/callback`;

      const { error } = await supabase.auth.signInWithOtp({
        email: trimmed,
        options: { emailRedirectTo: redirectTo },
      });

      if (error) throw error;

      // remember email just for UX (optional)
      try {
        localStorage.setItem("pendingEmail", trimmed);
      } catch {}

      setStatus("sent");
    } catch (err) {
      console.error("[landing] signInWithOtp error:", err);
      setError(err.message || "Could not send magic link");
      setStatus("idle");
    }
  }

  // ---------- SENT STATE (no code, just instructions) ----------
  if (status === "sent") {
    const pendingEmail =
      (typeof window !== "undefined" &&
        localStorage.getItem("pendingEmail")) ||
      email;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: "24px 16px",
          background:
            "radial-gradient(circle at top, #262626 0, #050505 55%, #000 100%)",
          color: "#eaeaea",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            borderRadius: 18,
            padding: 24,
            background: "rgba(10,10,10,0.9)",
            border: "1px solid #262626",
            boxShadow: "0 18px 60px rgba(0,0,0,0.6)",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img
              src="/tattoo/images/TatTune.png"
              alt="Tattune"
              style={{
                maxWidth: 140,
                height: "auto",
                marginBottom: 6,
                display: "inline-block",
              }}
            />
            <div
              style={{
                fontSize: 12,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "#9d9d9d",
              }}
            >
              Sign in
            </div>
          </div>

          <h2
            style={{
              fontSize: 18,
              margin: "0 0 8px",
              textAlign: "center",
              color: "#f5f5f5",
            }}
          >
            Check your email
          </h2>
          <p
            style={{
              fontSize: 13,
              lineHeight: 1.5,
              margin: "0 0 16px",
              textAlign: "center",
              color: "#c2c2c2",
            }}
          >
            We sent a one-time <strong>magic sign-in link</strong> to{" "}
            <strong>{pendingEmail}</strong>.  
            Open that email on this device and tap the link to enter your
            Tattune parlour.
          </p>

          {error && (
            <div
              style={{
                color: "#ff6b6b",
                marginTop: 10,
                fontSize: 13,
                textAlign: "center",
              }}
            >
              {error}
            </div>
          )}

          <p
            style={{
              marginTop: 18,
              fontSize: 11,
              textAlign: "center",
              color: "#707070",
            }}
          >
            <Link
              to="/privacy"
              style={{ color: "#9a9a9a", textDecoration: "underline" }}
            >
              Privacy policy
            </Link>
          </p>
        </div>
      </div>
    );
  }

  // ---------- DEFAULT (email capture) ----------
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0px 26px 0px 10px",
        background:
          "radial-gradient(circle at top, #262626 0, #050505 55%, #000 100%)",
        color: "#eaeaea",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 18,
          padding: 24,
          background: "rgba(10,10,10,0.9)",
          border: "1px solid #262626",
          boxShadow: "0 18px 60px rgba(0,0,0,0.6)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <img
            src="/tattoo/images/TatTune.png"
            alt="Tattune"
            style={{
              maxWidth: 160,
              height: "auto",
              display: "inline-block",
            }}
          />
        </div>

        <h1
          style={{
            fontSize: 20,
            margin: "0 0 8px",
            textAlign: "center",
            color: "#f5f5f5",
          }}
        >
          SIGN IN TO CONTINUE
        </h1>
        <p
          style={{
            fontSize: 13,
            margin: "0 0 16px",
            textAlign: "center",
            color: "#b0b0b0",
          }}
        >
          Enter your email and we&apos;ll send you a one-time magic link to
          enter your Tattune parlour.
        </p>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 12 }}
        >
          <input
            type="email"
            required
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            style={{
              width: "95%",
              padding: "10px 12px",
              borderRadius: 4,
              color: "#000000",
              fontSize: 14,
              outline: "none",
            }}
          />
          <button
            type="submit"
            disabled={status === "sending"}
            style={{
              width: "100%",
              color: "#c92d2d",
              padding: "10px 14px",
              borderRadius: 9999,
              border: "none",
              fontSize: 14,
              fontWeight: 600,
              cursor: status === "sending" ? "default" : "pointer",
              opacity: status === "sending" ? 0.7 : 1,
            }}
          >
            {status === "sending" ? "Sending…" : "Send magic link"}
          </button>
        </form>

        {error && (
          <div
            style={{
              color: "#ff6b6b",
              marginTop: 10,
              fontSize: 13,
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )}

        <p
          style={{
            marginTop: 18,
            fontSize: 11,
            textAlign: "center",
            color: "#707070",
          }}
        >
          No passwords. No spam. You can close this tab after you&apos;re done.
        </p>

        <p
          style={{
            marginTop: 6,
            fontSize: 11,
            textAlign: "center",
            color: "#707070",
          }}
        >
          <Link
            to="/privacy"
            style={{ color: "#9a9a9a", textDecoration: "underline" }}
          >
            Privacy policy
          </Link>
          {" · "}
          <Link
            to="/"
            style={{ color: "#9a9a9a", textDecoration: "underline" }}
          >
            Back to home
          </Link>
        </p>
      </div>
    </div>
  );
}